import { createSelector } from 'reselect'
import { selectCustomerRatingSettings } from './selectCustomerRatingSettings'
import { selectHasLoadedCustomerRatingSettings } from './selectHasLoadedCustomerRatingSettings'

export const selectCustomerRatingSettingsCountIfLoaded = createSelector(
  selectHasLoadedCustomerRatingSettings,
  selectCustomerRatingSettings,
  (loaded, settings) => (loaded ? (settings || []).length : null)
)
